module.exports = __webpack_public_path__ + "img/slika5.afb77d3e.jpg";